goog.provide('el8.tourguide.InfoBox');


el8.tourguide.InfoBox = function() {};

el8.tourguide.InfoBox.prototype.show = function(opts) {
    opts = opts || {};
    this._styleClass = opts.styleClass || 'tourGuideInfoBox';
    this._container = $('<div class="infobox-container">').addClass(this._styleClass);
    this._container.css({
        'height': opts.height || 400,
        'width': opts.width || 500,
        'left': opts.left || (opts.right !== undefined ? undefined : 0),
        'right': opts.right || undefined,
        'top': opts.top || 0,
        'z-index': opts.zIndex || 50
    });
    if (opts.contentFn) {
        this._container.html(opts.contentFn());
    }
    this._container.hide();
    if (opts.parentContainer) {
        opts.parentContainer.prepend(this._container);
    } else {
        $('body').prepend(this._container);
    }
    this._container.fadeIn();
};

el8.tourguide.InfoBox.prototype.hide = function(fade) {
    var that = this;
    if (this._container) { 
        if (fade === true) {
            this._container.fadeOut(400, function() {
                that._container.remove();
            });
        } else {
            this._container.remove(); 
        }
    }
};

el8.tourguide.InfoBox.prototype.getContainer = function() {
    return this._container;
};

el8.tourguide.InfoBox.prototype.adjustOffsets = function(opts) {
    opts = opts || {};
    if (opts.left !== undefined) {
        this._container.css({'left': opts.left});
    }
    if (opts.top !== undefined) {
        this._container.css({'top': opts.top});
    }
};

